import React from "react";
import useActive from "../../../../hooks/useActive";
import { Box, Button, Step, StepLabel, Stepper } from "@mui/material";
import RenderIf from "../../../Common/RenderIf/RenderIf";
import { useCreateElementContext } from "../Context/CreateElementContext";
import { isEmpty } from "lodash-es";
import { ErrorLabel } from "../../ElementForm";
import VideoDetails from "./VideoDetails";
import VideoContent from "./VideoContent";

const steps = ["Add details", "Add content"];

const REQUIRED_MESSAGE = "This field is required";

const validations = {
  0: ({ values }) => {
    const errors = {};

    if (!values?.tags || values?.tags?.length === 0)
      errors.tags = REQUIRED_MESSAGE;
    if (!values?.pass_percentage || values?.pass_percentage === "0")
      errors.pass_percentage = REQUIRED_MESSAGE;
    if (!values?.priority) errors.priority = REQUIRED_MESSAGE;
    if (!values?.thumbnail?.portrait)
      errors["thumbnail.portrait"] = REQUIRED_MESSAGE;
    if (!values?.thumbnail?.landscape)
      errors["thumbnail.landscape"] = REQUIRED_MESSAGE;
    if (values?.search_keywords && values.search_keywords?.length > 100)
      errors.search_keywords = "You can add max 100 keywords";
    return errors;
  },
  1: ({ values }) => {
    const errors = {};
    if (values?.content?.length === 0)
      errors.content = "Please add a default language";
    (values?.content ?? []).forEach((item, index) => {
      const key = `content.${index}.`;
      if (!item.title) errors[key + "title"] = REQUIRED_MESSAGE;
      if (item?.title?.length > 50)
        errors[key + "title"] = "Length of title can be max 50";
      if (!item.description) errors[key + "description"] = REQUIRED_MESSAGE;
      if (item?.description?.length > 250)
        errors[key + "description"] = "Length of description can be max 250";
      if (!item.duration) errors[key + "duration"] = REQUIRED_MESSAGE;
    });
    return errors;
  },
};

const AssessmentForm = ({}) => {
  const { active, handleActive } = useActive(0);
  const { form, handleCreate } = useCreateElementContext();

  const handleNext = () => {
    const validation = validations[active];

    const errors = validation({ values: form.values });

    if (isEmpty(errors)) {
      if (active === 0) {
      }
      if (active === 1) {
        handleCreate();
      } else {
        handleActive((active) => active + 1);
      }
    }
    form.setErrors(errors);
  };
  const handleBack = () => {
    if (active > 0) handleActive((active) => active - 1);
  };

  const errorMessage =
    Object.values(form.errors).filter(Boolean).length > 1
      ? `${
          Object.values(form.errors).filter(Boolean).length
        } errors, please correct`
      : Object.values(form.errors).join(", ");

  return (
    <Box>
      <Stepper
        activeStep={active}
        sx={{
          maxWidth: "656px",
          width: "75%",
          my: 3,
          mx: "auto",
        }}
      >
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};

          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <Box sx={{ border: "1px solid #D6D6D6", p: 4, borderRadius: 2 }}>
        <RenderIf condition={active === 0}>
          <VideoDetails />
        </RenderIf>
        <RenderIf condition={active === 1}>
          <VideoContent />
        </RenderIf>
      </Box>
      <Box
        mt={4}
        gap={2}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <ErrorLabel label={errorMessage} />
        <Box ml="auto" gap={2} display={"flex"}>
          <Button
            onClick={handleBack}
            //   disabled={isPending}
            color="error"
            variant="outlined"
          >
            Back
          </Button>
          <Button
            onClick={handleNext}
            //   disabled={isPending}
            color="error"
            variant="contained"
          >
            {active === 1 ? "Submit" : "Next"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AssessmentForm;
